var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7498 19.3844C13.5757 19.3844 13.4015 19.3202 13.264 19.1827L7.28734 13.2061C6.31568 12.2344 6.31568 10.6394 7.28734 9.66774L13.264 3.69107C13.5298 3.42524 13.9698 3.42524 14.2357 3.69107C14.5015 3.95691 14.5015 4.39691 14.2357 4.66274L8.25901 10.6394C7.81901 11.0794 7.81901 11.7944 8.25901 12.2344L14.2357 18.2111C14.5015 18.4769 14.5015 18.9169 14.2357 19.1827C14.0982 19.3111 13.924 19.3844 13.7498 19.3844Z",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftt);
export default __webpack_public_path__ + "static/media/leftt.eeda490ed6eafd543ebc36a49bf0e272.svg";
export { ForwardRef as ReactComponent };